module.exports = __webpack_public_path__ + "media/images/lalamove-new-d5f43a28202ef86334578166237db5e8.png";